
module.exports = {
	Home: {
        systemName: 'Management System',
		skinPeeler: 'Häutbare',
		help: 'Helfen',
        language: 'Sprache',
        Chinese: 'Chinesisch',
        English: 'Englisch',
        German: 'Deutsch'
	}
}


// WEBPACK FOOTER //
// ./src/lang/de.js